export function addTimer(timer) {
    return {
        type: "ADD_TIMER",
        timer: timer
    }
};